import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import navigation from 'src/components/layout/menu_items'
import { BASE_TITLE } from 'src/config'

const Breadcrumb = () => {
  const location = useLocation()

  const [item, setItem] = useState([])

  useEffect(() => {
    navigation.items.map((item, index) => {
      if (item.type && item.type === 'group') {
        getCollapse(item, index)
      }
      return false
    })
  })

  const getCollapse = (item, index) => {
    if (item.children) {
      item.children.filter(collapse => {
        if (collapse.type && collapse.type === 'collapse') {
          getCollapse(collapse, index)
        } else if (collapse.type && collapse.type === 'item') {
          if (location.pathname === collapse.url) {
            setItem(collapse)
          }
        }
        return false
      })
    }
  }

  let breadcrumbContent = ''
  let title = ''

  if (item && item.type === 'item') {
    title = item.title

    if (item.breadcrumbs !== false) {
      breadcrumbContent = (
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="page-header-title">
                  <h5 className="m-b-10">{title}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    document.title = title + BASE_TITLE
  }

  return <React.Fragment>{breadcrumbContent}</React.Fragment>
}

export default Breadcrumb
